import { render, staticRenderFns } from "./SupplierElement.vue?vue&type=template&id=3520544b&"
import script from "./SupplierElement.vue?vue&type=script&lang=js&"
export * from "./SupplierElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports